import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { getValue, tup } from '@virtuoso.dev/urx';
import { loggerSystem, LogLevel } from './loggerSystem';
export var propsReadySystem = u.system(function (_a) {
    var _b = __read(_a, 1), log = _b[0].log;
    var propsReady = u.statefulStream(false);
    var didMount = u.streamFromEmitter(u.pipe(propsReady, u.filter(function (ready) { return ready; }), u.distinctUntilChanged()));
    u.subscribe(propsReady, function (value) {
        value && getValue(log)('props updated', {}, LogLevel.DEBUG);
    });
    return { propsReady: propsReady, didMount: didMount };
}, tup(loggerSystem), { singleton: true });
